import { z } from 'zod';
/**
 * Lowercase-only UUID regex (cycle-1 C2).
 *
 * Intentionally NOT `z.string().uuid()` — Zod's built-in UUID validator
 * is case-insensitive and would accept 'AAAAAAAA-AAAA-AAAA-AAAA-AAAAAAAAAAAA'.
 * The domain VO (`createLogoId`) enforces lowercase-only and would throw
 * `MalformedLogoIdError` on uppercase input that passed a lenient schema.
 * Enforcing lowercase at the HTTP boundary produces a cleaner 422 from the
 * ZodValidationPipe rather than a domain error reaching the filter.
 */
const LOWERCASE_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
/**
 * Input schema for `POST /organizations/:slug/settings/logos`.
 *
 * `.strict()` rejects extra keys so that callers cannot smuggle
 * additional fields past the validation boundary.
 */
export const addLogoSchema = z
    .object({ logoId: z.string().regex(LOWERCASE_UUID) })
    .strict();
//# sourceMappingURL=add-logo.schema.js.map